import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AskQuestion } from '../models/AskQuestion';
import { Question } from '../models/Question';
import { QuestionFile } from '../models/QuestionFile';
import { AuthService } from './auth/auth.service';

@Injectable()
export class QuestionService {

  myHeader: Headers;

  Questions: Question[] = [];
  constructor(private auth: AuthService,
    private authHttp: AuthHttp) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('Question Service Initialized...');
  }

  pushQuestion(question: Question) {
    this.Questions.push(question);
  }

  popQuestion(): Question {
    return this.Questions.shift();
  }

  clear() {
    this.Questions = [];
  }

  submitQuestion(question: Question) {
    return this.authHttp.post(`/api/Question/SubmitWebToCaseQuestion`, question, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Submit question request has failed ' + res.status);
      } else {
        // console.log(res.json());
        return res;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  submitVendorQuestion(question: Question) {
    return this.authHttp.post(`/api/Question/submitVendorQuestion`, question, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Submit question request has failed ' + res.status);
      } else {
        // console.log(res.json());
        return res;
      }
    });
  }


  viewQuestions() {
    return this.authHttp.get(`/api/Question/GetWebToCaseQuestions`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Submit question request has failed ' + res.status);
      } else {
        // console.log(res.json());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  submitFile(questionFile: QuestionFile) {
    return this.authHttp.post(`/api/Question/WriteTemporaryFile`, questionFile, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Submit question request has failed ' + res.status);
      } else {
        // console.log(res.json());
        return res;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getVendorQuestions(gpVID: string) {
    return this.authHttp.get(`/api/Question/GetVendorQuestions?psGPVID=` + gpVID, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getVendorQuestions request has failed ' + res.status);
      } else {
        // console.log(res.json());
        return res.json();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/question.service.ts